var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Repeater_1;
import React, { Children, Fragment, PureComponent } from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { EditorContext } from '@philips-internal/oswald-ui-core/lib/component/context/editor-context.js';
import { arrayOf, element, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { propagateData } from '@philips-internal/oswald-ui-utils';
import RepeaterAPI from './repeater-api.js';
const RepeaterContainer = {
    name: '',
};
let Repeater = Repeater_1 = class Repeater extends PureComponent {
    render() {
        const { children, data = Repeater_1.defaultProps.data, uuid } = this.props;
        const shouldRenderContainer = (!children || Children.count(children) === 0) || this.context?.isDesigning();
        if (shouldRenderContainer) {
            return (React.createElement(Container, { className: "u-expand", repeated: true, uuid: uuid }, children));
        }
        return (React.createElement(Fragment, null, Array.isArray(data)
            ? data.map(item => propagateData(children, item, {}, true))
            : null));
    }
};
Repeater.contextType = EditorContext;
Repeater.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    data: arrayOf(object).notEnumerable(),
    uuid: string,
};
Repeater.defaultProps = {
    data: [],
};
Repeater = Repeater_1 = __decorate([
    AwesomeComponent({ api: RepeaterAPI, containers: [RepeaterContainer], type: ComponentType.BEHAVIOR })
], Repeater);
export { Repeater, };
export default Repeater;
//# sourceMappingURL=repeater.js.map